import propTypes from 'prop-types';
import ReactDOMServer from 'react-dom/server';
import {
  BsCheck2,
  BsCheckCircleFill,
  BsExclamationCircleFill,
  BsInfoCircleFill,
  BsXCircleFill,
} from 'react-icons/bs';
import Swal from 'sweetalert2';
import Styled from './alert-style';
import './swal.css';

/**
 * @description The Alert component
 * @param {object} props The props
 * @param {'info' | 'warning' | 'error' | 'success' | 'successSecondary'} props.icon The icon to display
 * @param {string} props.message The message to display
 * @param {string} props.text The text to display
 * @returns {void} The Alert component
 */
const Alert = ({ icon, text, message }) => {
  const renderIcon = () => {
    const iconToRender = {
      success: <BsCheckCircleFill className="green" size={32} />,
      successSecondary: (
        <Styled.WhiteBackground>
          <BsCheck2 className="green" size={24} />
        </Styled.WhiteBackground>
      ),
      error: <BsXCircleFill className="red" size={32} />,
      warning: <BsExclamationCircleFill className="orange" size={32} />,
      info: <BsInfoCircleFill className="blue" size={32} />,
    };
    return ReactDOMServer.renderToStaticMarkup(iconToRender[icon]);
  };

  Swal.fire({
    position: 'top-end',
    iconHtml: renderIcon(),
    showCloseButton: true,
    showConfirmButton: false,
    timerProgressBar: true,
    icon,
    title: text,
    text: message,
    customClass: {
      title: 'mixin-title',
    },
    timer: 3000,
    toast: true,
    allowOutsideClick: false,
    background: icon === 'successSecondary' ? '#000000' : '#ffffff',
    hideClass: { popup: '' },
  });
};

Alert.propTypes = {
  icon: propTypes.oneOf([
    'warning',
    'error',
    'success',
    'successSecondary',
    'info',
  ]),
  text: propTypes.string,
  message: propTypes.string,
};

Alert.defaultProps = {
  icon: 'success',
  text: 'This is an alert message',
  message: undefined,
};

export default Alert;
